/* eslint-disable */
var icon = require('vue-svgicon');
icon.register({
    'tablet-fill': {
        width: 16,
        height: 16,
        viewBox: '0 0 16 16',
        data: '<path pid="0" d="M2 2a2 2 0 012-2h8a2 2 0 012 2v12a2 2 0 01-2 2H4a2 2 0 01-2-2zm7 11a1 1 0 10-2 0 1 1 0 002 0"/>',
    },
});
